import de from './de';
import pl from './pl';

export default {
    de,
    pl
};